import { render, staticRenderFns } from "./FactsheetBar.vue?vue&type=template&id=2dbc12c9&scoped=true"
import script from "./FactsheetBar.vue?vue&type=script&lang=js"
export * from "./FactsheetBar.vue?vue&type=script&lang=js"
import style0 from "./FactsheetBar.vue?vue&type=style&index=0&id=2dbc12c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc12c9",
  null
  
)

export default component.exports